module.exports = __webpack_public_path__ + "static/media/cq_avanti.00d4bf57.svg";